import Graph12Leads from "./graph-12leads";
export default Graph12Leads;
